import React from 'react'

import Content, { Theme as ContentTheme } from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import ButtonRow from 'components/base/Button/Row'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import SectionDivider from 'components/base/SectionDivider'
import { QuoteIconPen } from 'components/base/Icon/styles'
import Form from 'components/base/Form'
import InputGroup from 'components/base/Form/InputGroup'
import { Type as InputType } from 'components/base/Form/Input/types'

import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'
import ProgressBar, { Type as ProgressBarType } from 'components/blocks/ProgressBar'

const QuotingSignature: React.FC = (): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.auto}>
    <ProgressBar type={ProgressBarType.autoRc2} current='all-finished' />

    <Title level={3}>
      Thanks Annika! In order to issue your insurance cards, we need you to
      sign your policy. We will send the contract to your email once it is
      ready.
    </Title>
    <Content theme={ContentTheme.paper} center={true}>
      <Content short={true}>
        <SectionDivider icon={<QuoteIconPen />} title='Signing Contract' />
        <Content margined={true} center={true}>
          <Paragraph theme={ParagraphTheme.centered}>
            Where would you like to receive your contract?
          </Paragraph>
          <Form short={true}>
            <InputGroup
              type={InputType.text}
              label='Email Address'
              name='email'
              rules='required|email'
            />
            <InputGroup
              type={InputType.text}
              label='Re-Enter Email Address'
              name='emailVerify'
              rules='required|email'
            />
          </Form>
        </Content>
      </Content>
    </Content>
    <Content margined={true}>
      <ButtonRow>
        <Link center={true} theme={LinkTheme.button} to='/quote/new/signature/success'>
          Send Contract for Signature
        </Link>
      </ButtonRow>
    </Content>
  </QuotingWrapper>
)

export default QuotingSignature
